import React, { useRef, useState } from "react";
import * as THREE from "three";
import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { useSpring, animated } from "@react-spring/three";
import {
  OrbitControls,
  Stars,
  Plane,
  MeshDistortMaterial,
} from "@react-three/drei";

import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { useEffect } from "react/cjs/react.production.min";
import { Camera } from "three";
import { PlaneBufferGeometry } from "three";
import "../Css/StarBackground.css"

function AddSphere({ position = [0, 0, 0], color = "#ffffff" }) {
  console.log(color);
  const ref = useRef();
  var opacity = 1;
  //動畫
  useFrame((state, delta) => {
    //ref.current.rotation.x += 0.01
    ref.current.position.z += delta * 500;

    if (ref.current.position.z > 1000) {
      ref.current.position.z = -1000;
    }
    //console.log(ref.current);
  });

  //邏輯....https://codepen.io/GraemeFulton/pen/BNyQMM

  //返回物件instance
  return (
    <mesh ref={ref} position={[position[0], position[1], position[2]]}>
      <boxGeometry args={[1.5, 1.5, 250]} />
      <MeshDistortMaterial
        attach="material"
        color={color}
        transparent
        opacity={Math.random()}
        distort={0.5}
        speed={1}
        roughness={1}
      />
    </mesh>
  );
}

export default function StarBackground() {
  const toP = useSpring({ rotation: [0, 180, 180] });

  return (
    <div className="sbg__root">
      <Canvas camera={{ rotation: toP.rotation }}>
        {
        <OrbitControls
          enablePan={true}
          enableZoom={false}
          enableRotate={false}
          makeDefault={true}
        />}
        {/* 黑天空背景 */}
        <Stars />
        <ambientLight intensity={0.5} />

        {Array(30)
          .fill(1)
          .map((el, i) => {
            var pos = [
              Math.random() * window.innerWidth - window.innerWidth / 2,
              Math.random() * window.innerHeight - window.innerHeight / 2,
              -i * 100,
            ];
            var randomColor = Math.floor(Math.random() * 16777215).toString(16);

            console.log(i);
            return <AddSphere position={pos} color={"#" + randomColor} />;
          })}
      </Canvas>
    </div>
  );
}
